import axios from 'axios';
import { API_URL } from '../constants';



const api = axios.create({
  baseURL: API_URL, 
  timeout: 10000, 
  headers: {
    'Content-Type': 'application/json',
  }
});



api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => response, 
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Session expirée, redirection...");
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;